__turbopack_context__.v({
  "content": "AppShellLayout-module-scss-module__BnyXaa__content",
  "scrollTop": "AppShellLayout-module-scss-module__BnyXaa__scrollTop",
  "scrollTopWrapper": "AppShellLayout-module-scss-module__BnyXaa__scrollTopWrapper",
});
